<template>
  <div class="funds-deposit">
    <div style="position: fixed; top: 50%; left: 50%; z-index: 999;">
      <atom-spinner
        v-if="loading"
        :animation-duration="speed"
        :size="config.size"
        :color="spinnersColor"
      />
    </div>
    <div class="mb-3" v-if="processingError">
      <va-notification color="danger" closeable>       
        An error occurred! Please Try again later.
      </va-notification>
    </div>
  	<div class="row">
      <div class="flex xs12 md6 lg6">
      	<va-card :title="$t('activities.deposit_form')">
          <form @submit.prevent="onsubmit">
            <va-input
              :label="$t('amount')"
              type="number"
              v-model="formdata.amount"
              :error="!!amountErrors.length"
              :error-messages="amountErrors"
            />
            <va-select
              class="mb-4"
              label="Account Type"
              v-model="formdata.type"
              textBy="description"
              :options="AccountTypes"
              key-by="id"
              @input="setSelected"
            />
            <va-select
              class="mb-4"
              label="Account"
              v-model="formdata.acc_code"
              textBy="accname"
              :loading = "loadSelect"
              :options="accounts"
              key-by="paybill_code"
            />

            <va-input               
              :label="$t('mpesa-phone')"
              v-model="formdata.phone_no"           
              :error="!!phoneErrors.length"
              :error-messages="phoneErrors"
            />

            <div class="row mt-5">            
              <va-button type="submit" >
                {{ $t('forms.controls.submit') }}
              </va-button>                        
            </div>
          </form>
        </va-card>
      </div>
    </div>
    <va-modal
      v-model="showConfirmModal"
      position="top"
      size = "medium"
      :title=" $t('confirm_trans')"
      cancelClass="none"      
      :okText=" $t('modal.confirm') "     
      :cancelText=" $t('modal.cancel')"      
      noOutsideDismiss
      noEscDismiss
      @ok = "FinalPost"
    >
      <table class="va-table va-table--striped va-table--hoverable" width="100%">
        <tbody>
          <tr>
            <td>Account</td>
            <td style="text-align: right;">{{ acc_details.accname }}</td>
          </tr>
          
          <tr>
            <td>Payment Phone No</td>
            <td style="text-align: right;">{{ paying_phone_no }}</td>
          </tr>
          
          <tr>
            <td>Account Balance</td>
            <td style="text-align: right;"> {{ acc_details.balance | Currency }} </td>
          </tr>                   
          <tr>
            <td>Deposit Amount</td>
            <td style="text-align: right;"> {{ deposit_amount | Currency }} </td>
          </tr> 
          <tr>
            <td>New Account Balance</td>
            <td style="text-align: right;"> {{ acc_details.balance - -  deposit_amount  | Currency }} </td>
          </tr>          
        </tbody>
      </table>
    </va-modal>
  </div>
</template>
<script>
import axios from 'axios'
import * as spinners from 'epic-spinners'
export default {
  components: {
    ...spinners      
  },
  name: 'funds-deposit',
  data () {
    return {
      userData: JSON.parse(localStorage.getItem('LoggedUser')),
      accdetails: JSON.parse(localStorage.getItem('UserMianFosa')),
      token: JSON.parse(localStorage.getItem('Token')), 
      loading: false,
      processingError: false,
      loadSelect:false,
      showConfirmModal : false,
      acc_details:{
        accname : '',
        balance : '',
      },
      deposit_amount:'',
      paying_phone_no:'',      
      accounts:JSON.parse(localStorage.getItem('UserFosas')),
      fosas:JSON.parse(localStorage.getItem('UserFosas')),
      config: {
        size: 80,
        duration: 1500,
      },
      spinnersColor: this.$themes.secondary,
      currentDuration: 1500,
      sliderDuration: {
        min: 1000,
        max: 2000,
      },
      formdata:{
        amount:'',
        user: '',
        acc_code: '',
        type:'',
        phone_no: '',
      },
      amountErrors : [],
      phoneErrors: [],
      AccountTypes: [
        {
          id: '',
          description: 'select an Option',
        },
        {
          id: 'fosa',
          description: 'Fosa (Deposit To savings)',
        },
        {
          id: 'bosa',
          description: 'Bosa (Deposit to Bosa)',
        },
      ],
      showBosa: false,
      showFosa: false,
      acc_code : {},
      selected : {},
      postdata : {},
    }
  },
  computed: {
    speed () {
      return this.sliderDuration.min + this.sliderDuration.max - this.currentDuration
    },

    formReady () {
        return !this.amountErrors.length && !this.phoneErrors.length
    }
  }, 
  methods : {
    getSelected(acc_code){
      console.log(acc_code)
      return this.accounts.find(item => 
        item.paybill_code.toLowerCase() == acc_code.toLowerCase()
      )
    },
    onsubmit () {
      this.processingError = false;
      this.amountErrors = this.formdata.amount ? [] : ['Amount is required']
      this.phoneErrors = this.formdata.phone_no  ? [] : ['Phone No is required']

      if (this.formReady) {        
        this.paying_phone_no = this.formdata.phone_no         
          
        this.acc_details = this.getSelected(this.formdata.acc_code.paybill_code);
        this.deposit_amount = this.formdata.amount;
        this.showConfirmModal = true;
      }
    }, 

    FinalPost () {
      const selected = this.formdata.acc_code
      this.formdata.acc_code = this.formdata.acc_code.paybill_code
      const msg = "Enter M-pesa pin on payong phone to complete";
      this.loading = true
      var self = this

      let config = {
        headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
      }


      axios.post(`${this.$apiUrl}depositMoneyFinal`, this.formdata, config)
      .then(function (res) {
        self.loading = false
        self.formdata.acc_code = selected
        const resp = res.data
        if(resp.response.success == '1'){              
          self.showToast(`Payment Processed succefully ${msg}`, {
            position: 'bottom-right',
            icon: "fa-check",
            duration: 2500,
          })
          //setTimeout( () => self.$router.go(-1), 2500);
        } else {
          self.processingError = true
        }                  
      })
      .catch(function (error) {
          console.log(error)
      })
    },

    loadBosaAccs(){      
      this.loadSelect = true;
      const self = this
      let config = {
        headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
      }

      axios.post(`${self.$apiUrl}GetBackOfficeAccounts`, self.userData.user_id, config)
      .then(function (res) {
        self.accounts = res.data
        self.loadSelect = false;
      })
      .catch(function (error) {
        console.log(error)
      })
    },

    setSelected(value){
      this.formdata.acc_code = {};
      const val = value.id
      if (val) {
        if (val == 'fosa'){
          this.accounts = this.fosas
          this.loadSelect = false;
          this.showFosa = true
          this.showBosa = false
        } else {
          this.showBosa = true
          this.showFosa = false
          this.loadBosaAccs();
        } 
      }
    }
  },
  created () { 
    this.formdata.phone_no  = this.userData.mobile_number
    this.formdata.user  = this.userData.user_id    
  } 
} 
</script>
   
